<template>
    <v-flex>
        <h1>Words</h1>
    </v-flex>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>